import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import { DeleteDialog } from '../Dialogs'
import EditButton from '../Generic/EditButton'
import ShowButton from '../Generic/ShowButton'

const styles = {
    container : {
        width : 80,
        display : 'flex',
        justifyContent : 'space-evenly',
        '& button' : {
            width: 20,
            height: 20,
            '& svg' : {
                fontSize : 18
            }
        }
    },
}

const RowActions = (props) => {
    if (props.permissions === null) {
        return null
    }
    const { basePath, record, permissions: { role }, classes } = props

    const editButton = (
        <Tooltip title="Editar">
            <EditButton basePath={basePath} record={record}/>
        </Tooltip>
    )
    const showButton = (
        <Tooltip title="Ver">
            <ShowButton basePath={basePath} record={record}/>
        </Tooltip>
    )
    const deleteButton = (
        <Tooltip title="Eliminar">
            <DeleteDialog {...props}/>
        </Tooltip>
    )

    if (role === "admin" || role === "coordinador") {
        return (
            <div className={classes.container}>
                {showButton}
                {editButton}
                {deleteButton}
            </div>
        )
    } else if (role === "externo") {
        return (
            <div className={classes.container}>
                {showButton}
                {editButton}
            </div>
        )
    } else if (role === "coordinado") {
        return (
            <div className={classes.container}>
                {showButton}
            </div>
        )
    } else if (role === "guest"){
        return (
            <div className={classes.container}>
                {showButton}
            </div>
        )
    }
}

export default withStyles(styles)(RowActions)
